import React, { useState } from "react";
import "antd/dist/antd.min.css";
import {
  Row,
  Form,
  Menu,
  Affix,
  Button,
  Space,
  Drawer,
  Card,
  Input,
  Divider,
  Avatar,
  Select
} from "antd";

const Header2 = () => {
  return (
    <Affix offsetTop={0} className="app__affix-header">
      <nav className="navbar">
        <div
          className="brand-title"
          onClick={() => {
            window.location.reload();
          }}
        >
          <Space>
            <img width={45} src="./RIHES_Logo-White.png" />

            <a
              style={{
                fontWeight: "bold",
                color: "white"
              }}
            >
              RIHES Research Management System
            </a>
          </Space>
        </div>
      </nav>
    </Affix>
  );
};
export default Header2;
